// import axios from 'axios';
// const domain = window.location.origin;

// axios.defaults.baseURL = domain;
// const request = axios.create({
//   baseURL: `${domain}/w1`,
//   transformResponse: [(response) => {
//     console.log('domain', domain);
//     if (response) {
//       return JSON.parse(response).data;
//     }
//     return null;
//   }],
// });

// export default request;

import axios from 'axios';
import appConfig from "../config/api.config";

const isDev = window.location.hostname === 'localhost';
const url = appConfig.BASE_URL;
const request = axios.create({
  baseURL: `${url}/w1`,
  withCredentials: true,
  transformResponse: [(response) => {
    if (response) {
      const parsed = JSON.parse(response);
      if (parsed.error) return parsed;
      return parsed.data;
    }
    return null;
  }],
});

request.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      const isAuthPage = path.startsWith('/signin')
        || path.startsWith('/signup')
        || path.startsWith('/forgot-password');
      if (!isAuthPage) {
        window.location.replace('/signin');
      }
    }
    return Promise.reject(error);
  },
);

export default request;